import { useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Footer from './Footer'
import Header from './Header'
import ScrollToTop from './ScrollToTop'

const NO_FOOTER_ROUTES = ['experience']

const Layout = () => {
  const { pathname } = useLocation()
  const hideFooter = useMemo(() => NO_FOOTER_ROUTES.includes(pathname.split('/')[1] ?? ''), [pathname])

  return (
    <>
      <ScrollToTop />
      <div className="h-full min-h-screen dark:bg-primary">
        {/* A "layout route" is a good place to put markup you want to
          share across all the pages on your site, like navigation. */}
        <Header />

        {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
        <Outlet />

        {!process.env.REACT_APP_COMING_SOON_PREVIEW && !hideFooter && <Footer />}
      </div>
    </>
  )
}

export default Layout
